const setTabIndex = (elements: (HTMLElement | null)[], value: string) => {
    elements.forEach(el => el?.setAttribute('tabindex', value));
};

const getNewsletterItems = (root: ParentNode | null): (HTMLElement | null)[] => {
    if (!root) return [];
    return [
        root.querySelector('.foot-nav-accordion-content .input-newsletter input'),
        root.querySelector('.foot-nav-accordion-content .input-newsletter .input-newsletter-button'),
    ];
};

const changeHandler = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const accordion = target.closest('.foot-nav-accordion');
    const label = (target.closest('div')?.querySelector('.foot-nav-accordion-label')) as HTMLElement | null;

    if (!accordion) return;

    const isNewsletter = accordion.classList.contains('foot-newsletter');
    const tabIndexValue = target.checked ? '0' : '-1';

    if (isNewsletter) {
        const newsletterItems = getNewsletterItems(accordion);
        setTabIndex(newsletterItems, tabIndexValue);
    } else {
        const links = accordion.querySelectorAll<HTMLElement>('.foot-nav-accordion-content a');
        setTabIndex(Array.from(links), tabIndexValue);
    }

    label?.focus();
};

const applyTabIndexSettings = (footNav: HTMLElement, isMobile: boolean) => {
    const tabIndex = isMobile ? '-1' : '0';

    const links = footNav.querySelectorAll<HTMLElement>('.foot-nav a');
    setTabIndex(Array.from(links), tabIndex);

    const newsletterItems = getNewsletterItems(footNav);
    setTabIndex(newsletterItems, tabIndex);

    const labels = footNav.querySelectorAll<HTMLElement>('.foot-nav-accordion-label');
    labels.forEach(label => {
        if (isMobile) {
            label.setAttribute('role', 'button');
        } else {
            label.removeAttribute('role');
        }
    });

    if (isMobile) {
        const checkboxes = footNav.querySelectorAll<HTMLInputElement>('.foot-nav-accordion-input');
        checkboxes.forEach(checkbox => {
            checkbox.removeEventListener('change', changeHandler); // Sicherheitshalber entfernen
            checkbox.addEventListener('change', changeHandler);
        });
    }
};

export const addChangeEventFooterMenu = () => {
    const footNav = document.querySelector<HTMLElement>('.foot-nav');
    if (!footNav) return;

    const updateView = () => {
        const isMobile = window.innerWidth < 768;
        applyTabIndexSettings(footNav, isMobile);
    };

    updateView(); // initial ausführen
    window.addEventListener("resize", updateView); // beim Zoom oder beim Ändern der Fenstergröße ausführen
};
